import {getTableOptions, getAticleColumns} from '@/components/component/AdminHome/getArticleData.js'
import {getAppliedFilters, loader} from '@/libs/helper'
import {isEmpty, cloneDeep} from 'lodash'
import {getContentList, bulkUpdate} from '@/libs/api/api'

export default {
    data () {
        return {
            limit: 10,
            currentPage: 1,
            skipArticles: 0,
            selectedValue: 10,
            totalTableData: 0,
            previousPage : 1,
            articleSort: 'title',
            articleOrder: 'desc',
            pubColumns: [],
            pubTableOptions: {},
            pubTableData: [],
            selectedTableFilters: {},
            cityFilter: false,
            filterData: [],
            nameFilterData: [],
            cityFilterData: [],
            citySearch: '',
            tableFilters: {},
        }
    },
    mounted () {
        // columns
        this.pubColumns = getAticleColumns()

        // table options
        this.pubTableOptions = getTableOptions()

        // set type
        this.$store.dispatch('setType', 'ARTICLE')
    },
    methods: {
       /**
        * get articles list for article tab
        */
       getArticles: async function () {
            loader(this,true)
            try {
                let body = getAppliedFilters(cloneDeep(this.selectedTableFilters))
                const metaId = this.$route.params.id
                // if edit publication
                if (this.$route.name === 'editPublications') body.publication_id = metaId

                // edit publisher page
                else if (this.$route.name === 'editPublishers') body.publisher_id = metaId

                // edit author page
                else if (this.$route.name === 'editAuthors') body.author_id = metaId
                // body.publication_id = this.$route.params.id

                // params
                let params= `?skip=${this.skipArticles}&limit=${this.limit}&sort=${this.articleSort}&order=${this.articleOrder}`

                // response afor article list
                let response = await getContentList('contents', params, body)

                // assign article items
                this.pubTableData = cloneDeep(response.items)

                // count for pagination
                this.totalTableData = response.total_count
                loader(this, false)
            }
            catch(error){
                loader(this, false)
                console.warn(error)
            }
        },

        /**
         * 
         * @param {*} record 
         */
        changeRecord (record) {
            this.selectedValue = record
        },
        changePage (currentPage) {
            this.previousPage = this.currentPage
            this.currentPage = currentPage
            this.skipArticles = (currentPage - 1) * this.selectedValue
            this.getArticles()
        },

        refreshPage(){
            this.changePage(this.currentPage)
        },

        sorting (type, order, sort) {
            this.skipArticles = 0
            this.order= order
            this.currentPage = 1
            this.articleSort = sort
            this.getArticles()
        },

        setTableFilters (filters) {
            this.selectedTableFilters = cloneDeep(filters)
            this.$store.dispatch('setTableFilters', filters)
            this.filterCall()
        },

        applyFilters () {
            let filtersToApply = {}
            if (!isEmpty(this.selectedTableFilters)) {
                if (this.selectedTableFilters.city && this.selectedTableFilters.city.length > 0) {
                    filtersToApply.city = this.selectedTableFilters.city
                }
                if (this.selectedTableFilters.name && this.selectedTableFilters.name.length > 0) {
                    filtersToApply.name = this.selectedTableFilters.name
                }
            } 
            this.selectedTableFilters = filtersToApply
            return this.selectedTableFilters
        },

        filterCall() {
            this.changePage(1)
        },

        handleArticleTablesCommand (command, data) {
            switch (command) {
                case 'EDIT':
                    this.$router.push({name: 'editArticles', params: {id: data._id}})
                break
                case 'DELETE':
                    this.deleteTableRow('CONTENT', data)
                break
            }
        },

        deleteTableRow (module, data) {
            let body = {
                entity_ids: [data._id],
                delete_from_ecosystem: true
            }
            bulkUpdate(module.toLowerCase(), body).then(() => {
                this.changePage(this.currentPage)
            }).catch(error => {
                console.error(error)
            })
        },
    }
}